'use client'

import DraftMode from '../../v2/components/DraftMode'
import { HeaderMenu } from '../../v2/components/HeaderMenu'
import CookieBar from '../common/cookie-bar'
import Button from '../ui/button'
import LineFooter from './footer/line-footer'
import { useAcceptCookies } from '@telesoft/lib/web/use-accept-cookies'
import { Footer, MainMenu, MainMenuCtaButton, SocialProfile } from '@telesoft/types/payload-types'
import React, { ReactNode } from 'react'
import { Toaster } from 'react-hot-toast'

interface Props {
  children: ReactNode
  globals: {
    mainMenu: MainMenu
    footer: Footer
    socials: { profiles: SocialProfile[] }
    ctaButtons: MainMenuCtaButton
  }
  variant?: 'default' | 'fixed'
  previewMode?: boolean
}

const Template: React.FC<Props> = ({
  children,
  globals,
  variant = 'default',
  previewMode = false,
}) => {
  const { acceptedCookies, onAcceptCookies } = useAcceptCookies()
  const { mainMenu, footer, socials, ctaButtons } = globals

  return (
    <React.Fragment>
      {previewMode && <DraftMode />}
      <div className="relative flex flex-col min-h-screen">
        <HeaderMenu mainMenu={mainMenu} ctaButtons={ctaButtons} variant={variant ? variant : "default"} {...mainMenu} />
        <main
          className="relative flex-grow"
          style={{
            minHeight: '-webkit-fill-available',
            WebkitOverflowScrolling: 'touch',
          }}
        >
          {children}
        </main>
        <LineFooter footer={footer} socials={socials} />
        <Toaster
          position="bottom-center"
          toastOptions={{
            style: {
              borderRadius: 0,
              fontSize: '14px',
              borderTop: '1px solid',
              borderColor: '#1ea1dc',
              background: '#000',
              color: 'white',
            },
            loading: {
              duration: 3000,
            },
          }}
        />
        <CookieBar
          title="Telesoft use cookies to improve your browsing experience."
          hide={acceptedCookies}
          action={
            <Button
              onClick={() => onAcceptCookies()}
              variant="cta"
              invert={true}
              className="text-white"
            >
              ACCEPT
            </Button>
          }
        />
      </div>
    </React.Fragment>
  )
}

export default Template
